export type PlanLang = "ko" | "en" | "mn" | "vi" | "zh-CN";

export const PLAN_LANGS: PlanLang[] = ["ko", "en", "mn", "vi", "zh-CN"];

export const PLAN_REQUIRED_LANGS: PlanLang[] = ["ko", "en"];

export const PLAN_LANG_LABELS: Record<PlanLang, string> = {
  ko: "한국어",
  en: "English",
  mn: "Монгол",
  vi: "Tiếng Việt",
  "zh-CN": "简体中文",
};

/**
 * i18n JSONB 필드에서 현재 언어로 읽기. 순서:
 * 1) 요청 언어
 * 2) en (필수라 항상 존재)
 * 3) ko
 * 4) legacy 단일 텍스트 필드 (fallbackLegacy)
 * 5) 빈 문자열
 */
export function pickI18n(
  i18n: Record<string, string> | null | undefined,
  lang: string,
  fallbackLegacy?: string | null,
): string {
  if (i18n && typeof i18n === "object") {
    const v = i18n[lang];
    if (v && v.trim()) return v;
    if (i18n.en && i18n.en.trim()) return i18n.en;
    if (i18n.ko && i18n.ko.trim()) return i18n.ko;
  }
  if (fallbackLegacy && fallbackLegacy.trim()) return fallbackLegacy;
  return "";
}
